import React from 'react';
import Clipboard from 'react-clipboard.js';
import StatusButton from '../StatusButton/StatusButton.js';
import './Server.css';
import minecraftLogo from './images/Minecraft_logo.svg';
import terrariaLogo from './images/terrariaLogo.jpg';

class Server extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      server: props.server
    };
  }
  render() {
    var gameImage = this.state.server.game;
    if (this.state.server.game === 'minecraft') {
      gameImage = <img src={minecraftLogo} alt="Minecraft" />;
    } else if (this.state.server.game === 'terraria') {
      gameImage = <img src={terrariaLogo} alt="Terraria" />;
    }

    var serverPack = this.state.server.modPack;
    if (serverPack !== 'Vanilla' && this.state.server.game === 'terraria') {
      serverPack = (
        <a
          href={
            process.env.PUBLIC_URL +
            '/modpacks/terraria/' +
            this.state.server.modPack +
            '.json'
          }
          download
        >
          {this.state.server.modPack}
        </a>
      );
    }

    return (
      <tr className="server">
        <td>{gameImage}</td>
        <td>{serverPack}</td>
        <td>{this.state.server.world}</td>
        <td>
          <ul className="list-unstyled">
            {this.state.server.hostnames.map(hostname => (
              <Clipboard data-clipboard-text={hostname}>
                <li>{hostname}</li>
              </Clipboard>
            ))}
          </ul>
        </td>
        <td>
          <StatusButton server={this.state.server} />
        </td>
      </tr>
    );
  }
}

export default Server;



// WEBPACK FOOTER //
// ./src/components/ServersList/Server/Server.js